<div class="h-full w-full flex flex-col">
  @let type = previewType();
  @if (linkFile()) {
    <p>Link files have no downloadable content.</p>
  } @else if (type === 'unsupported') {
    <app-unsupported-preview [file]="file()"/>
  } @else if (loading()) {
    <div class="w-full h-full flex items-center justify-center">
      <app-loading-indicator>Loading file...</app-loading-indicator>
    </div>
  } @else if (error()) {
    <app-preview-error [error]="error()"/>
  } @else {
    @switch (type) {
      @case ('image') {
        <div class="w-full h-full flex items-center justify-center [app-file-form_&]:block [app-file-form_&]:overflow-y-auto [app-file-form_&]:p-8 [app-file-form_&]:[scrollbar-gutter:stable] [app-file-form_&::-webkit-scrollbar]:w-8 [app-dynamic-panel_app-file-form_&]:p-6">
          <img [src]="fileUrl()" alt="file preview" class="max-w-full max-h-full [app-file-form_&]:block [app-file-form_&]:w-full [app-file-form_&]:h-auto [app-file-form_&]:max-h-none"/>
        </div>
      }
      @case ('pdf') {
        @defer (on immediate) {
          <app-pdf-preview [file]="fileUrlString()" />
        } @loading (after 100ms) {
          <stch-top-progress-task />
          <div class="w-full h-full flex items-center justify-center" role="status" aria-live="polite">
            <app-loading-indicator>Loading PDF viewer...</app-loading-indicator>
          </div>
        } @error {
          <p role="alert">The PDF viewer could not be loaded. Reload the page to try again.</p>
        }
      }
      @case ('text') {
        <app-text-preview [blob]="blob()" [renderAsMarkdown]="renderAsMarkdown()"/>
      }
      @case ('docx') {
        <app-word-preview [blob]="blob()"/>
      }
      @case ('spreadsheet') {
        <app-spreadsheet-preview [blob]="blob()"/>
      }
      @case ('presentation') {
        <app-presentation-preview [blob]="blob()"/>
      }
    }
  }
</div>
